import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CloseButtonLayout } from '../../features/facecake/layouts/close-button-layout';
import { FaceCakePlanManagement } from '../../features/facecake/facecake-plan-management';

export const FaceCakePlanManagementPage = () => {
  const navigate = useNavigate();
  return (
    <CloseButtonLayout
      onBackClick={() => {
        navigate('/');
      }}
    >
      <FaceCakePlanManagement variant="page" />
    </CloseButtonLayout>
  );
};
